// import { useMutation, useQuery } from "@tanstack/react-query";

import { useMutation } from '@tanstack/react-query';
import { useSnackbar } from '../stateless/SnackBarProvider';
import { useProfileApi } from '../../Hooks/useProfileApi';



export const useEditProfile = () => {
//   const queryClient = useQueryClient();
  const { showMessage } = useSnackbar();
  const { editProfile } = useProfileApi();

  return useMutation({
    mutationKey: ['EditProfile'],
    mutationFn: ({ id, data }: { id: string; data: any }) =>
      editProfile(id, data),
    onSuccess: (response: any) => {
      showMessage(
        response?.message || 'Profile Updated successfully',
        'success'
      );
    //   queryClient.invalidateQueries({
    //     queryKey: ['getChoiceGroup'],
    //     exact: false,
    //   });
    },
    onError: (error: any) => {
      const apiMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message;
      showMessage(apiMessage || 'Failed to update password', 'error');
    },
  });
};
